import * as React from 'react';
import { Summary } from '../Models/Report';
import './SummaryItem.scss';
import { formatAmount } from '../Utils/NumberFormat';
import Balloon from './Balloon';


export interface ISummaryItemProps {
	data: Summary;
}


const SummaryItem = (props: ISummaryItemProps) => {
	const color = props.data.color;
	return (<div className="SummaryItem">
		<div className="SummaryItem-name">
			<Balloon color={color} size={16} />
			<span>{props.data.name}</span>
		</div>
		<div className="SummaryItem-total">
				<span style={{ borderBottom: `1px solid ${color}` }}>
					{formatAmount(props.data.total)}
					<span>kton</span>
				</span>
		</div>
	</div>)
};

export default SummaryItem;
